<template>
  <div class="contact-us">
    <div
      class="box-map"
      v-for="(item, index) in mydata.addressCardArr"
      :key="index"
    >
      <!-- 地图-->
      <div class="content-left">
        <div :id="'my-map-' + index" class="my-map"></div>
      </div>
      <!-- 信息 -->
      <div class="content-right">
        <p>{{ item.company }}</p>
        <div class="box-line"></div>
        <p>电话：{{ item.tel }}</p>
        <p>地址：{{ item.address }}</p>
      </div>
    </div>

    <!-- 代理发售图书，请联系大区经理-->
    <div class="box-call">
      <div class="call-head">
        <p>代理发售图书，请联系大区经理</p>
      </div>
      <div class="call-content">
        <p v-for="(item, index) in mydata.districtAgentTelArr" :key="index">
          {{ item.title }}: {{ item.tel }}
        </p>

       
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted, nextTick } from "vue";
// 引入高德地图插件
import AMapLoader from "@amap/amap-jsapi-loader";

// 引入接口
import {
  addressCardList,
  districtAgentTelList,
} from "@/api/walkIntroTianLi/contactUsThree/index.js";

const mydata = reactive({
  contactUs: [
    {
      title1: "西藏天利教育科技有限公司 北京总部",
      title2: "010-51655511",
      title3: "北京市朝阳区东土城路8号 林达大厦 A座 13层",
      imgSrc: require("@/assets/03fc35c92aaf4605442a3105952c9e2c_tianli-logo 4.png"), // 图片地址
      longitude: 116.43279, // 经度
      latitude: 39.955865, // 纬度
    },
    {
      title1: "西安分公司",
      title2: "010-51655511",
      title3: "北京市朝阳区东土城路8号 林达大厦 A座 13层",
      imgSrc: require("@/assets/03fc35c92aaf4605442a3105952c9e2c_tianli-logo 4.png"), // 图片地址
      longitude: 116.43279, // 经度
      latitude: 39.955865, // 纬度
    },
    {
      title1: "长春分公司",
      title2: "010-51655511",
      title3: "北京市朝阳区东土城路8号 林达大厦 A座 13层",
      imgSrc: require("@/assets/03fc35c92aaf4605442a3105952c9e2c_tianli-logo 4.png"), // 图片地址
      longitude: 116.43279, // 经度
      latitude: 39.955865, // 纬度
    },
  ],

  // 图片基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  addressCardArr: [], //地址卡片

  districtAgentTelArr: [], //区代理发售上联系电话
});

// 初始化地图
function initAMap(elementId, imgSrc, longitude, latitude) {
  AMapLoader.load({
    key: "c0f2396e74eddbcc5d9d10d563bdb6a4", // 申请好的Web端开发者Key密钥
  }).then((AMap) => {
    let map = new AMap.Map(elementId, {
      // 设置地图容器id值
      zoom: 16, // 初始化地图级别
      center: [longitude, latitude], // 初始化地图中心点位置
    });

    ///////////////////////////////
    //信息窗体内容
    var content = [
      `
      <div class='my-map-infoWindow'>
        <img src='${imgSrc}' />
        <div class="my-map-spike"></div>
      </div>
      
      `,
    ];

    //创建信息窗体
    var infoWindow = new AMap.InfoWindow({
      content: content.join("<br>"), //传入字符串拼接的DOM元素
      anchor: "bottom-center", // 锚点方位
      isCustom: true, // 开启自定义样式
    });

    //打开信息窗体
    infoWindow.open(map, map.getCenter()); //map为当前地图的实例，map.getCenter()用于获取地图中心点坐标。
    ///////////////////////////////
  });
}

// 地址卡片
function addressCardFn() {
  addressCardList({}).then((res) => {
    // 赋值
    mydata.addressCardArr = res.data;
    // 【注意】必须在拿到接口数据之后，进行初始化地图。否则空数组的时候初始化了地图，当数组改变的时候，地图是不会自己自动进行再次初始化的。
    nextTick(() => {
      // 遍历
      mydata.addressCardArr.forEach((item, index) => {
        // 初始化
        initAMap(
          "my-map-" + index,
          mydata.VUE_APP_BASE_HOST + item.image,
          item.longitude,
          item.latitude
        );
      });
    });
  });
}

onMounted(() => {
  addressCardFn();
});

// 区代理发售上联系电话
function districtAgentTelFn() {
  districtAgentTelList({}).then((res) => {
    mydata.districtAgentTelArr = res.data;
    // console.log(res.data, "区代理发售上联系电话");
  });
}

districtAgentTelFn();
</script>

<style scoped lang="scss">
.contact-us {
  width: 343px;
  margin: 0 auto;
  margin-top: 16px;
  margin-bottom: 40px;
  //   border: 1px solid red;
  .box-map {
    // height: 338px;
    margin-bottom: 16px;
    // border: 1px dashed blue;
    // display: flex;
    border-radius: 8px;
    box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.0509803922);
    .content-left {
      width: 100%;
      height: 100%;
      padding: 16px;
      background-color: #ffffff;
      border-radius: 8px 8px 0px 0px;
      // border: 1px solid rgb(255, 136, 0);
    }
    .content-right {
      width:343px;
      // height: 100%;
      // margin-top:10px;
      padding:16px;
      // padding-left: 76px;
      background-color: #009de0;
      border-radius: 0px 0px 8px 8px;
      p:nth-of-type(1) {
        // margin-top: 110px;
        font-size: 18px;
        font-weight: 700;
        color: #ffffff;
        margin-bottom: 18px;
      }
      .box-line {
        width: 29px;
        height: 2px;
        background-color: #ffffff;
        margin-bottom: 18px;
      }
      p:nth-of-type(2),
      p:nth-of-type(3) {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 22px;
        margin-bottom: 8px;
      }
      p:nth-of-type(3) {
        margin-bottom: 0px;
      }
    }
  }
  .box-map:nth-of-type(3) {
    margin-bottom: 0px;
  }

  .box-call {
    width: 343px;
    // height: 260px;
    margin-top: 24px;
    border-radius: 8px;
    box-shadow: 0px 5px 40px 0px #0000000d;

    // border: 1px solid rgb(0, 255, 0);
    .call-head {
      height: 60px;
      //   border: 1px solid red;
      background-image: url("@/assets/Rectangle 1168.png");
      // box-shadow: 0px 5px 40px 0px #0000000D;
      border-radius: 8px 8px 0px 0px;

      p {
        font-size: 18px;
        font-weight: 700;
        line-height: 60px;
        text-align: center;
        color: #333333;
      }
    }
    .call-content {
      // height: calc(260px - 80px);
      //border: 1px solid rgb(89, 0, 255);

      // width: 987px;
      // height: 120px;
      // border:1px solid red;
      margin: 0 auto;
      // display: flex;

      // flex-wrap: wrap;
      padding: 16px;
      p {
        width:255px;
        // margin-left: 40px;
        font-size: 14px;
        font-weight: 400;
        line-height: 34px;
        color: #000000;
        margin:0 auto;
        // border:1px solid rgb(0, 26, 255);
      }
      // .detail-box {
      //   width: 269px;
      //   // border:1px solid pink;
      //   display: flex;
      //   flex-direction: column;
      //   justify-content: space-between;
      //   p {
      //     font-size: 14px;
      //     font-weight: 400;
      //     line-height: 22px;
      //     color: #000000;
      //   }
      // }
    }
  }
}

// 地图
.my-map {
  width: 100%;
  height: 278px;
  // border: 1px solid rgb(0, 38, 255);
}

:deep(.my-map-infoWindow) {
  width: 125px;
  height: 63px;
  border-radius: 9px;
  // border: 1px solid rgb(255, 0, 0);
  background: #fff;
  position: relative;
  top: -10px;
  // 样式就在这里自己调就行
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 90px;
    height: 30px;
  }
}
:deep(.my-map-spike) {
  width: 0px;
  height: 0px;
  border: 22px solid transparent;
  border-top: 22px solid #ffffff;
  position: absolute;
  top: 45px;
  left: 35px;
}
</style>
